import { Avatar, Dropdown, Spinner } from 'components/ui'
import { SessionContext } from 'contexts/SessionContext'
import React, { useContext,  useRef, useState } from 'react'
import { HiOutlineUser } from 'react-icons/hi';
import { PLACEMENT } from 'components/ui/utils/constant';
import PostArticle from 'views/posts/PostArticle';
import usePostGenerator from 'utils/hooks/usePostGenerator';
import { BsInputCursor, BsStars } from 'react-icons/bs';
import ConfigPanelPostTypesOptions from 'views/post_playground/ConfigPanelPostTypesOptions';
import { ModalContext } from 'contexts/ModalContext';
import { useWhitelabel } from 'contexts/WhitelabelThemeContext';

function makeBold(text){
  var bold = /\*\*(.*?)\*\*/gm;
  var html = text.replace(bold, '<strong>$1</strong>');            
  return html;
}

export default function ChatTemplateMessage({
  aiResult
}) {
  const { whitelabel } = useWhitelabel();
  const { user } = useContext(SessionContext);
  const [ openedPostGroup, setOpenedPostGroup ] = useState();
  const [ selection, setSelection ] = useState();
  const { generateEmptyPost, generateFromContext } = usePostGenerator();
  const { openModal, closeModal } = useContext(ModalContext);
  const [ useAIToWriteAbout, setUseAIToWriteAbout ] = useState(false);
  const [ isNetworksOpened, setIsNetworksOpened ] = useState(false);
  const messageRef = useRef();
  const dropdownRef = useRef();


  const responseArray = aiResult?.response?.replaceAll("\"", "")?.replaceAll("“", "")?.split("\n");

  const open = async (network, description) => {
    openModal(<div className='w-full h-[200px] flex items-center justify-center'><Spinner size={30} /></div>, 300);
    let postGroup = undefined;
    if (useAIToWriteAbout) {
      postGroup = await generateFromContext(network, description, undefined, undefined, "none");
      postGroup = postGroup?.[0];
    } else {
      postGroup = generateEmptyPost(network);
      postGroup.posts[0].description = network == "medium" ? description?.replaceAll(`\n\n`, `<br/>`) : description?.replaceAll(`\n\n`, `\n`);
    }
    if (postGroup) {
      setOpenedPostGroup(postGroup);
    }
    closeModal();
  }

  return (
    <>
      <div className='flex gap-2 text-sm lg:text-base'>
        <div className='shrink-0 border border-gray-300 dark:border-gray-600 rounded-full flex flex-col items-center justify-center h-[24px] w-[24px]'>
          <img src={whitelabel?.logo} className='!w-auto !h-[16px]' />
        </div>
        <div className='flex flex-col gap-1'>
          <span className='font-bold text-tertiary-800 dark:text-white mt-[1px]'>{whitelabel?.name} AI</span>
          <span className='text-gray-800 dark:text-white whitespace-pre-wrap'>
            {aiResult?.status === 'failed' && !aiResult?.response
              ? <span className='text-red-500'>{aiResult?.status_message || 'This answer could not be generated. Please try again.'}</span>
              : aiResult?.response === undefined || (['pending', 'processing'].includes(aiResult?.status) && !aiResult?.response)
              ? <Spinner size={24} />
              : <div
                className='flex flex-col gap-2.5' 
                ref={messageRef}
                onContextMenu={(ev) => {
                  ev.preventDefault();
                  const selection = window.getSelection()?.toString() || document?.selection?.createRange()?.htmlText;
                  setSelection(selection);
                  setIsNetworksOpened(false)
                  if (ev.target && !!selection) ev.target.closest('.dropdown-toggle').click();
                }}
              >
                {responseArray?.map(p => {
                  const plainText = p.replace(/^\s*(?:[\dA-Z]+\.|[a-z]\)|•)\s+/gm, '');
                  return (
                    <Dropdown
                      ref={dropdownRef}
                      postType={undefined}
                      menuClassName="!max-h-[300px] !z-[150] zoom-90 max-w-[200px] !py-2"
                      placement={PLACEMENT.CENTER_CENTER}
                      hideChecks={true}
                      parentClassName="!p-0 !inline-block !m-0 editable-response"
                      renderTitle={
                        <p>
                          <span>{p.match(/^\s*(?:[\dA-Z]+\.|[a-z]\)|•)\s+/gm)}</span>
                          <span 
                            className='actual-text' 
                            onClick={() => { setSelection(undefined); setIsNetworksOpened(false) }}
                            dangerouslySetInnerHTML={{ __html: makeBold(plainText) }}
                          />
                        </p>
                      }
                    >
                      {isNetworksOpened 
                        ? <ConfigPanelPostTypesOptions 
                          setPostType={(postType) => open(postType, selection || plainText)}
                          hideChecks={true}
                        />
                        : <>
                          <Dropdown.Item className="!px-0">
                            <div onClick={(e) => { e.stopPropagation(); setUseAIToWriteAbout(true); setIsNetworksOpened(true); }} className="flex justify-between items-center gap-2 !px-4 !py-2 cursor-pointer dark:text-gray-200 hover:bg-gray-100 dark:hover:bg-gray-600 w-full text-sm">
                              <div className='flex items-center gap-2'>
                                <span className="shrink-0">
                                  <BsStars className='text-lg text-fuchsia-500' />
                                </span>
                                <span className="shrink-0">Use AI to write about...</span>
                              </div>
                            </div>
                          </Dropdown.Item>
                          <Dropdown.Item className="!px-0">
                            <div onClick={(e) => { e.stopPropagation(); setUseAIToWriteAbout(false); setIsNetworksOpened(true); }} className="flex justify-between items-center gap-2 !px-4 !py-2 cursor-pointer dark:text-gray-200 hover:bg-gray-100 dark:hover:bg-gray-600 w-full text-sm">
                              <div className='flex items-center gap-2'>
                                <span className="shrink-0">
                                  <BsInputCursor className='text-lg text-primary-600' />
                                </span>
                                <span className="shrink-0">Post selected text...</span>
                              </div>
                            </div>
                          </Dropdown.Item>
                        </>
                      }
                    </Dropdown>
                  );
                })}
              </div>
            }
          </span>
        </div>
      </div>
      
      <div className='flex gap-2 text-sm lg:text-base'>
        <Avatar size={24} shape="circle" src={user?.image?.url} icon={<HiOutlineUser />} />
        <div className='flex flex-col gap-1'>
          <span className='font-bold text-tertiary-800 dark:text-white mt-[1px]'>You</span>
          <span className='text-gray-800 dark:text-white whitespace-pre-wrap'>{aiResult?.query}</span>
        </div>
      </div>

      {!!openedPostGroup && 
        <PostArticle 
          key={openedPostGroup?.id || 1}
          item={openedPostGroup}
          forceFullScreen={true}
          setOpenedPostGroup={setOpenedPostGroup}
          showOptionsButton={false}
        />
      }
    </>
  );
}

